/* eslint-disable use-encapsulation/prefer-custom-hooks */
/* eslint-disable @typescript-eslint/no-misused-promises */

//TODO[SETTINGS] Remove disabled lint control on Promise
import { useFetchUser } from '@/hooks';
import { Container, Box, Flex, Modal, useDisclosure } from '@chakra-ui/react';
import type {
  IAuthSignupFields,
  ISetNewPassword,
  ISetNewPhoneNumber,
  ISetUserAddress,
} from '@/types';
import { useTranslation } from 'react-i18next';
import {
  SettingCard,
  UserSettingsInfoBox,
  SettingsPhoneModal,
  SettingsPasswordModal,
  SettingUserAddressModal,
  DeliveryAddressBook,
} from '../components';
import { Section } from '../components/Section';
import { useUserApi } from '../api';
import { Auth } from '@aws-amplify/auth';
import { useState } from 'react';

export const UserSettings = (): JSX.Element => {
  const { t } = useTranslation();
  const { fetch: updateUser, isLoading, user } = useFetchUser();
  const userApi = useUserApi();
  const { isOpen: isOpenPhone, onClose: onClosePhone, onOpen: onOpenPhone } = useDisclosure();
  const [isModifyLoading, setIsModifyLoading] = useState<boolean>(false);
  const [hasPasswordChanged, setHasPasswordChanged] = useState<boolean>(false);

  const {
    isOpen: isOpenPassword,
    onClose: onClosePassword,
    onOpen: onOpenPassword,
  } = useDisclosure();

  const { isOpen: isOpenAddress, onClose: onCloseAddress, onOpen: onOpenAddress } = useDisclosure();

  const handleSettingNewPhoneNumber = async (data: ISetNewPhoneNumber): Promise<void> => {
    setIsModifyLoading(true);

    if (user && data.newPhoneNumber) {
      const updatedUser: IAuthSignupFields = { ...user, phone: data.newPhoneNumber };
      await userApi.updateUser(updatedUser);
      setIsModifyLoading(false);
      updateUser();
    }

    onClosePhone();
  };

  const handleSettingNewPassword = (data: ISetNewPassword): void => {
    setIsModifyLoading(true);

    const { newPassword, oldPassword }: ISetNewPassword = data;

    //TODO[PASSWORD CHANGE] Export method and handle errors

    if (newPassword && oldPassword) {
      Auth.currentAuthenticatedUser()
        .then(async (user) => {
          return Auth.changePassword(user, oldPassword, newPassword);
        })
        .then((_data) => setHasPasswordChanged(true))
        .catch((error) => console.log(error));
    }

    setIsModifyLoading(false);
  };

  const handleSettingUserAddress = async (data: ISetUserAddress): Promise<void> => {
    setIsModifyLoading(true);

    if (user) {
      const updatedUser: IAuthSignupFields = { ...user, ...data };
      await userApi.updateUser(updatedUser);
      setIsModifyLoading(false);
      updateUser();
    }

    onCloseAddress();
  };

  return (
    <Box bg="white" py={16} w="full">
      <Container maxW="8xl" py={{ base: 8, lg: 20 }}>
        <Flex flexDirection="column" gap={24}>
          <Section id="settings" title={t('ACCOUNT.SETTINGS.ACCOUNT_SETTINGS_TITLE')}>
            <UserSettingsInfoBox isLoading={isLoading} user={user} />
            <Flex
              direction={{ md: 'row', base: 'column' }}
              gap="2%"
              justifyContent="flex-start"
              rowGap={{ lg: '0', base: '30px' }}
            >
              <SettingCard
                content={user?.phone}
                title={t('ACCOUNT.SETTINGS.PHONE')}
                onOpen={onOpenPhone}
              />
              <SettingCard
                content="****"
                title={t('ACCOUNT.SETTINGS.PASSWORD')}
                onOpen={(): void => {
                  setHasPasswordChanged(false);
                  onOpenPassword();
                }}
              />
              <SettingCard
                address={
                  user && {
                    city: user.city,
                    province: user.province,
                    streetAddress: user.streetAddress,
                    zipCode: user.zipCode,
                  }
                }
                title={t('ACCOUNT.SETTINGS.ADDRESS')}
                onOpen={onOpenAddress}
              />
            </Flex>
          </Section>
          <Section id="settings" title={t('ACCOUNT.SETTINGS.DELIVERY_ADDRESS_TITLE')}>
            <DeliveryAddressBook />
          </Section>
        </Flex>
      </Container>

      <Modal
        isOpen={isOpenPhone}
        onClose={(): void => {
          onClosePhone();
        }}
      >
        <SettingsPhoneModal
          isLoading={isModifyLoading}
          phoneNumber={user?.phone}
          onSubmit={handleSettingNewPhoneNumber}
        />
      </Modal>

      <Modal
        isOpen={isOpenPassword}
        onClose={(): void => {
          onClosePassword();
        }}
      >
        <SettingsPasswordModal
          hasChanged={hasPasswordChanged}
          isLoading={isModifyLoading}
          onSubmit={handleSettingNewPassword}
        />
      </Modal>

      <Modal
        isOpen={isOpenAddress}
        onClose={(): void => {
          onCloseAddress();
        }}
      >
        <SettingUserAddressModal
          city={user?.city}
          countryCode={user?.countryCode}
          isLoading={isModifyLoading}
          province={user?.province}
          streetAddress={user?.streetAddress}
          zipCode={user?.zipCode}
          onSubmit={handleSettingUserAddress}
        />
      </Modal>
    </Box>
  );
};
